/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsCycleSubmissionsInfo } from '../../models/submissions-cycle-submissions-info';

export interface GetSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Params {
  org: string;
}

export function getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet(http: HttpClient, rootUrl: string, params: GetSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsCycleSubmissionsInfo>>> {
  const rb = new RequestBuilder(rootUrl, getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsCycleSubmissionsInfo>>;
    })
  );
}

getSubmissionsCyclesInformationApiV2SubmissionsCycleOrgSubmissionsInfoGet.PATH = '/api/v2/submissions-cycle/{org}/submissions/info';
